import React, {useState, useEffect, useRef} from 'react';
import {
  Link,
  useParams,
  useHistory
} from "react-router-dom";
import PageForm from '../../components/PageEditForm';
import {uploadFile} from '../../Utils.js';
import slugify from 'slugify';
import moment from 'moment';

export default function AccountPageAdd({ showMessage, userId }) {
  const defaultPage = {
    title: '',
    slug: '',
    public: false,
    content: '',
    sidebarTitle: '',
    sidebarContent: ''
  };
  const [page, setPage] = useState(defaultPage);
  const [error, setError] = useState('');
  const [login, setLogin] = useState(false);

  let history = useHistory();

  document.title = 'Creating Page | Sublunary Admin';


  const submit = async () => {
    let updatedPage = {...page}
    updatedPage.slug = slugify(updatedPage.title, {lower: true, strict: true});
    let data = await window.ASTERISM.makeRequest(`create-page?id=${userId}`, 'POST', updatedPage);
    if (data.ok) {
      showMessage({text: 'Page successfully created!', temp: true, type: 'success'});
      history.push(`/my-account/pages/${data.id}`);
    }
  }

  if (error) {
    return (
      <div className='edit-bar'><div className='edit-title'>{error} {login && <Link to={`/login?return=${window.location.pathname}`}><button className='secondary-submit'>Login</button></Link>}</div></div>
    )
  }

  return (
    <div className=''>
      <div className='edit-bar'>
        <div className='edit-title'>Creating a New Post</div>
        <button className='main-submit' onClick={submit}>Create Post</button>
      </div>
      <PageForm setPage={setPage} page={page} />
    </div>
  )
}
